import { ReactNode, useContext, useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import "./SystemSettings.css";
import BasicTab from "../../component/SystemSettings/BasicTab/BasicTab";
import RolesSystem from "../../component/SystemSettings/RolesSystem/RolesSystem";
import SystemUsers from "../../component/SystemSettings/SystemUsers/SystemUsers";
import { AppContext } from "../../App";
import SafetySettings from "../../component/SystemSettings/SafetySettings/SafetySettings";
import LicenseList from "../../component/SystemSettings/LicenseList/LicenseList";
import NamedLicenses from "../../component/SystemSettings/NamedLicenses/NamedLicenses";
import SessionManager from "../../component/SystemSettings/SessionManager/SessionManager";
import WidgetContainer from "../../component/UiLib/WidgetContainer/WidgetContainer";
import { CurrentTab, TabNavigator } from "../../component/UiLib/TabNavigator/TabNavigator";
import { hasPermission } from "../../helpers/hasPermisson";

type tabType = [string, string, ReactNode];

const licenseTabs: tabType[] = [["licensesList", "Список лицензий", <LicenseList />]];
const systemTabs: tabType[] = [
    ["main", "Основные", <BasicTab />],
    ["users", "Пользователи", <SystemUsers />],
    ["roles", "Список ролей", <RolesSystem />],
    ["security", "Безопасность", <SafetySettings />],
    ["activeSessions", "Активные сессии", <SessionManager />],
    ["namedLicenses", "Именные лицензии", <NamedLicenses />],
];

const SystemSettings = () => {
    const { setBreadCrumb, setNavPanelHighlight, systemUserAccess } = useContext(AppContext);

    const viewSystemSettings = useMemo(() => {
        return (
            hasPermission(systemUserAccess, "SystemAction", "view") ||
            hasPermission(systemUserAccess, "SystemAction", "edit")
        );
    }, [systemUserAccess]);

    const viewLicenseSettings = useMemo(() => {
        return (
            hasPermission(systemUserAccess, "LicenseAction", "view") ||
            hasPermission(systemUserAccess, "LicenseAction", "edit")
        );
    }, [systemUserAccess]);

    const tabs: tabType[] = [...(viewSystemSettings ? systemTabs : []), ...(viewLicenseSettings ? licenseTabs : [])];

    useEffect(() => {
        setBreadCrumb([]);
        setNavPanelHighlight(undefined);
    }, []);

    return (
        <div className="system-settings-component">
            <WidgetContainer style={{ height: "100%" }}>
                <TabNavigator queryParamName="tab">
                    {tabs.map((tab) => (
                        <CurrentTab key={tab[0]} name={tab[1]}>
                            {tab[2]}
                        </CurrentTab>
                    ))}
                </TabNavigator>
            </WidgetContainer>
        </div>
    );
};

export default observer(SystemSettings);
